import mixins from '../mixins'
import render from '../mixins/render'
import { mapState } from 'vuex'

export default {
  name: 'DialogModal',
  mixins: [mixins, render],
  props: {
    component: Object,
    /**
     * Send parameters to Component
     * you need use props to receive this params in component
     */
    params: Object,
    /**
     * Full screen dialog
     */
    fullWidth: {
      type: Boolean,
      default: false
    },
    maxButton: {
      type: Boolean,
      default: true
    },
    closeButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      maximize: false,
      animate: false
    }
  },
  computed: {
    classes() {
      return {
        'v-dialog': true,
        'v-dialog-modal': true,
        'v-dialog--maximize': this.maximize,
        'v-dialog--buzz-out': this.shake
      }
    },
    maxClass() {
      return this.maximize ? 'dlg-icon-restore' : 'dlg-icon-max'
    },
    ...mapState('check', ['beforeClose'])
  },
  render(h) {
    const child = []
    // dialog header
    if (this.titleBar !== false) {
      const buttons = []
      if (this.closeButton) {
        buttons.push(
          h(
            'button',
            {
              class: 'v-dialog-btn__close',
              attrs: {
                type: 'button'
              },
              on: {
                click: () => {
                  if (this.beforeClose) {
                    //检查弹框关闭前弹确认框
                    this.$Confirm(
                      '您填写的内容尚未保存，确定要离开吗？',
                      '提示',
                      {
                        showCancelButton: true,
                        cancelButtonText: '取消',
                        confirmButtonText: '确定',
                        type: 'warning'
                      }
                    )
                      .then(() => {
                        this.closeDialog(true)
                        this.$store.state.check.beforeClose = false
                      })
                      .catch(() => {})
                    if (
                      document.getElementsByClassName('v-dialog-modal')
                        .length == 1
                    ) {
                      document.getElementsByClassName(
                        'v-dialog-modal'
                      )[0].style.zIndex = 1500
                      document.getElementsByClassName(
                        'v-dialog-overlay'
                      )[0].style.zIndex = 1499
                    }
                  } else {
                    this.closeDialog(true)
                  }
                }
              }
            },
            [h('i', { class: 'dlg-icon-font dlg-icon-close' })]
          )
        )
      }
      if (this.maxButton) {
        buttons.push(
          h(
            'button',
            {
              class: 'v-dialog-btn__maximize',
              attrs: {
                type: 'button'
              },
              on: {
                click: this.max
              }
            },
            [
              h('i', {
                class: ['dlg-icon-font', this.maxClass]
              })
            ]
          )
        )
      }
      child.push(
        h(
          'div',
          {
            class: 'v-dialog-header',
            ref: 'header'
          },
          [...buttons, h('h3', this.titleBar)]
        )
      )
    }
    // dialog body
    child.push(
      h(
        'div',
        {
          class: 'v-dialog-body',
          style: {
            height: this.bodyHeight + 'px'
          }
        },
        [
          // Dynamic component
          h(this.component, {
            props: this.params,
            on: {
              close: this.modalClose
            }
          })
        ]
      )
    )

    const dialog = h(
      'div',
      {
        class: {
          'v-dialog-dialog': true,
          'v-dialog-default-animated': this.animate
        },
        style: {
          width: this.width + 'px',
          height: this.height + 'px',
          top: this.dialogTop < 0 ? 0 : this.dialogTop + 'px'
        }
      },
      [
        this.buildDlgContent(h, {
          className: 'v-dialog-content',
          transitionName: 'v-dialog--smooth',
          child: child
        })
      ]
    )

    return h('div', [this.buildDlgScreen(h, dialog), this.buildBackdrop(h)])
  },
  methods: {
    /**
     * dialog max size
     */
    max() {
      if (!this.animate) this.animate = true
      this.maximize = !this.maximize
      this.modalAdjust()
    },
    modalAdjust() {
      if (this.maximize) this.dialogTop = 0
      else this.adjust()
    },
    modalClose(data) {
      this.closeDialog(false, data)
    }
  },
  mounted() {
    if (this.fullWidth) {
      this.max()
    }
    this.$nextTick(() => {
      if (this.titleBar) {
        const headerHeight = this.$refs.header.offsetHeight // this.$refs.header.getBoundingClientRect().height;
        this.bodyHeight = this.height - headerHeight
      } else this.bodyHeight = this.height

      this.modalAdjust()
    })
  }
}
